module.exports = __webpack_public_path__ + "img/widget_placeholder.e78a9971.jpg";